export default __webpack_public_path__ + "static/media/cprofile5.f50c43ee.png";